import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const ROUND_TYPES = [
  {
    value: 'PRE_SEED',
    label: 'Pre-Seed',
    desc: 'Early idea-stage capital from angels or accelerators',
  },
  { value: 'SEED', label: 'Seed', desc: 'First institutional round to prove product-market fit' },
  {
    value: 'SAFE',
    label: 'SAFE',
    desc: 'Simple Agreement for Future Equity — fast, no valuation needed now',
  },
  {
    value: 'SERIES_A',
    label: 'Series A',
    desc: 'Growth capital with institutional investors and board seats',
  },
  { value: 'SERIES_B', label: 'Series B', desc: 'Scale capital to expand markets and team' },
  { value: 'BRIDGE', label: 'Bridge', desc: 'Short-term financing to reach next milestone' },
  {
    value: 'SECONDARY',
    label: 'Secondary',
    desc: 'Existing shares changing hands between parties',
  },
] as const;

interface RoundTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export function RoundTypeSelector({ value, onChange }: RoundTypeSelectorProps) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {ROUND_TYPES.map((rt) => (
        <button
          key={rt.value}
          type="button"
          onClick={() => onChange(rt.value)}
          className={cn(
            'text-left p-4 rounded-xl border transition-all duration-150',
            'hover:border-primary/30 hover:bg-muted/30',
            value === rt.value
              ? 'border-primary bg-primary/5 ring-1 ring-primary/20'
              : 'border-border'
          )}
        >
          <p className="text-sm font-medium">{rt.label}</p>
          <p className="text-xs text-muted-foreground mt-1">{rt.desc}</p>
        </button>
      ))}
    </div>
  );
}

export { ROUND_TYPES };
